import { IPromoInfoSchema } from '../../../types/promo';

export const getAuthorName = (promo: IPromoInfoSchema): string | null | undefined => {
  const isCianMortgage = promo.promoType === 'cianMortgage';

  return isCianMortgage ? 'Циан.Ипотека' : promo.authorName;
};
